module.exports = __webpack_public_path__ + "img/key_inactive.d994742c.svg";